import { Injectable } from '@angular/core';
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {Presenter} from "../../../internal/presenter/presenter";
import {DataService} from "../../../../services/external-api/data.service";

@Injectable({
  providedIn: 'root'
})
export class ApiIrAdminService {

  constructor(
    private presenter: Presenter,
    private dataService: DataService,
    private configurationManager: ConfigurationManager
  ) { }



}
